import React from "react";
// import { CheckCircle, XCircle } from "lucide-react";
import { Check, X } from "lucide-react";
import { useParams } from "react-router-dom";

export default function Compare() {
  const { topic } = useParams();
  const formattedTopic = topic
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const data = [
    { feature: "Discover higher emails volume", exact: true, topic: false },
    { feature: "Find more verified emails", exact: true, topic: false },
    { feature: "Pay only for Verified Emails", exact: true, topic: false },
    { feature: "Unused Credit Rollover", exact: true, topic: false },
    { feature: "Duplicated searches", exact: true, topic: true },
    { feature: "LinkedIn Email Finder", exact: true, topic: false },
    { feature: "Search by Decision Maker", exact: true, topic: false },
    { feature: "Bulk Email Finder", exact: true, topic: true },
    { feature: "Email Finder API", exact: true, topic: true },
    { feature: "Unlimited Team Members", exact: true, topic: true },
    { feature: "Make and Zapier integrations", exact: true, topic: true },
    { feature: "Support", exact: true, topic: true },
  ];

  return (
    <div className="flex justify-center items-center min-h-screen py-12">
      <div className="w-full mx-10 shadow-sm border-[1px] border-gray-200 rounded-xl overflow-hidden bg-white">
        <table className="w-full text-left border-collapse rounded-lg overflow-hidden">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-5 px-8 text-gray-800 font-bold text-base xl:text-xl border-b">
                Comparing Exact Mails vs. {formattedTopic}
              </th>
              <th className="py-5 px-8 text-center text-green-600 font-bold text-base xl:text-lg border-b">
                Exact Mails
              </th>
              <th className="py-5 px-8 text-center text-red-600 font-bold text-base xl:text-lg border-b">
                {formattedTopic}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.map(({ feature, exact, topic }, index) => (
              <tr
                className={`hover:bg-gray-100 ${
                  index % 2 === 0 ? "bg-gray-50" : ""
                }`}
                key={index}
              >
                <td className="py-4 px-8 text-gray-800 border-b text-base">
                  {feature}
                </td>
                <td className="py-4 px-8 text-center border-b">
                  {exact && topic && feature === "Duplicated searches" ? (
                    <span className="text-green-600 text-sm">
                      Free within 1 year
                    </span>
                  ) : exact ? (
                    <div className="inline-flex items-center justify-center rounded-full bg-green-100 p-1">
                      <Check className="text-green-600" size={22} />
                    </div>
                  ) : (
                    <div className="inline-flex items-center justify-center rounded-full bg-red-100 p-1">
                      <X className="text-red-600" size={22} />
                    </div>
                  )}
                </td>
                <td className="py-4 px-8 text-center border-b">
                  {exact && topic && feature === "Duplicated searches" ? (
                    <span className="text-green-600 text-sm">
                      Free within 1 year
                    </span>
                  ) : topic ? (
                    <div className="inline-flex items-center justify-center rounded-full bg-green-100 p-1">
                      <Check className="text-green-600" size={22} />
                    </div>
                  ) : (
                    <div className="inline-flex items-center justify-center rounded-full bg-red-100 p-1">
                      <X className="text-red-600" size={22} />
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
